/**
 * This is our global redux store.
 * It is set up to work using generated reducers using createSlice these can be found in ./src/store/reducers
 *
 * A new reducer can be generated by running:
 * npx generate-react-cli component --type=reducer Something
 *
 * Which will generate ./src/store/something/something-actions.tsx and ./src/store/something/something-slice.tsx
 */

import { configureStore } from '@reduxjs/toolkit';
import sideMenuSlice from './side-menu/side-menu-slice';
import powerplantSlice from './powerplant/powerplant-slice';

const selectedPowerplantString = localStorage.getItem('selectedPowerplant')
const persistedPowerplant = selectedPowerplantString ? JSON.parse(selectedPowerplantString) : null;

export const store = configureStore({
  reducer: {
    sideMenu: sideMenuSlice.reducer,
    powerplant: powerplantSlice.reducer,
  },
  preloadedState: {
    powerplant: persistedPowerplant || { _id: undefined, name: undefined }
  }
});


// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {sideMenu: SideMenuState, powerplant: PowerplantState etc..}
export type AppDispatch = typeof store.dispatch
